import SelectedIdCard from './components/IDCards/SelectedIdCard';
import SelectedPanCard from './components/PANCards/SelectedPanCard';
import { TAB_KEYS } from './constant';
import styles from './index.module.scss';
import { IRightPanel } from './interface';

const RightPanel = (props: IRightPanel) => {
  const { selectedTabKey } = props;
  return (
    <div className={styles.rightPanel}>
      {selectedTabKey === TAB_KEYS.ID_CARDS ? <SelectedIdCard /> : <SelectedPanCard />}
    </div>
  );
};

export default RightPanel;
